import { LINE_ICONS } from './nav-line-icons.js';

// One line icon per navigation item (lib/navigation.js ids): the set in
// brand/onguard/icons/sidebar-line, drawn on a 24 grid at 20 px, stroke 1.75,
// round caps, in currentColor so the sidebar's text color, hover and current
// states apply. Decorative: the label is always the accessible name.
const ALIAS = {
  'fleet-overview': 'collections',
  customers: 'company-settings',
  // ENTRAID-347 redesign: Data collection keeps the Sources database icon.
  'data-collection': 'sources',
};

const FALLBACK = 'overview';

export default function NavIcon({ id, className = 'h-5 w-5' }) {
  const name = ALIAS[id] ?? id;
  const key = LINE_ICONS[name] ? name : FALLBACK;
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      data-nav-icon={key}
    >
      <path d={LINE_ICONS[key]} />
    </svg>
  );
}
